export default __webpack_public_path__ + "static/media/dmv-lg.cfc7183e.jpg";